import '../../styles/CopyButton.css';

/**
 * SVG-иконка "копировать", используемая внутри CopyButton.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {number} [props.width=22] - Ширина иконки в пикселях.
 * @param {number} [props.height=22] - Высота иконки в пикселях.
 * @param {string} [props.fill='#32A74C'] - Цвет иконки (stroke).
 * @returns {JSX.Element} SVG-элемент иконки.
 */

const CopyIcon = ({ width = 22, height = 22, fill = '#32A74C' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    stroke={fill}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

/**
 * Кнопка копирования.
 * При клике вызывает переданную функцию onCopy.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} [props.onCopy] - Колбэк, вызываемый при клике. Предполагается, что он выполняет копирование в буфер.
 * @returns {JSX.Element} Кнопка с иконкой копирования.
 */
const CopyButton = ({ onCopy }) => {
  const handleClick = (e) => {
    e.stopPropagation(); // чтобы не срабатывал клик по строке таблицы
    onCopy?.();
  };

  return (
    <button onClick={handleClick} className="copy-coords-button">
      <CopyIcon />
    </button>
  );
};

export default CopyButton;
